import { HttpResponse } from 'msw';

type LegacyBody = { command?: string; access?: string };

export function handleNtpLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (command) {
    case 'get config':
      if (access === 'get') {
        return HttpResponse.json(
          {
            enable: true,
            server: 'pool.ntp.org',
            queryInterval: 6,
          },
          { status: 200 },
        );
      }
      break;
    case 'set config':
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      break;
    default:
      break;
  }

  return HttpResponse.json(
    { error: 'not implemented', msg: `Mock missing for ntp:${command}` },
    { status: 400 },
  );
}
